module.exports = __webpack_public_path__ + "media/assets/images/connectors/servicenow-logo-82e9a426b58fb4b883fce67f5a8ed3d8.png";